import Header from '../navigation/headerContainer';
import Footer from '../navigation/footerContainer';
import RegisterForm from './registerFrom';

export default function RegisterPage() {
    return(
        <>
            <Header />
            <RegisterForm />
            <Footer />
        </>
    )
}